import { useTranslation } from '@mint-lib/i18n';
import { SortDescending } from '@mint-lib/icons';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@mint-lib/tw-components';

import { sortFilter } from '../../../constants/integrationsList.js';

type DownloadTagsMenuProps = {
  selected: string;
  sortFnBy: (sort: string) => void;
};

export default function FilterSortBy({
  selected,
  sortFnBy,
}: DownloadTagsMenuProps) {
  const { t } = useTranslation('@myn/integrations_v2');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          color="secondary"
          size="large"
          variant="text"
          data-dd-action-name="open sort menu"
        >
          <SortDescending />
          {t('Sort by')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-60">
        <DropdownMenuItem
          onClick={() => sortFnBy(sortFilter.label)}
          selected={selected === 'label'}
        >
          {t('A-Z')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => sortFnBy(sortFilter.connectionType)}
          selected={selected === 'connectionType'}
        >
          {t('Connection type')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
